import { render, staticRenderFns } from "./ClientPanel.vue?vue&type=template&id=20dda34c&scoped=true"
import script from "./ClientPanel.vue?vue&type=script&lang=js"
export * from "./ClientPanel.vue?vue&type=script&lang=js"
import style0 from "./ClientPanel.vue?vue&type=style&index=0&id=20dda34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dda34c",
  null
  
)

export default component.exports